<template>
    <main-content with_go_back_bar>
        <div v-show="wizard.show" class="bg-white my-3" style="border-radius: 20px; box-shadow: 0 0 5px #8ce3d6;">
            <div v-if="wizard.current_step > 0" class="d-flex align-items-center justify-content-around mb-3 p-4">
                <div @click="goto_step(1)" :style="wizard.current_step > 0 ? 'cursor: pointer !important;' : ''">
                    <div class="text-center mt-2">
                    <span :style="wizard.current_step > 0 ? 'color: #00bea5' :'color: #d2d2d2'">{{
                            $t('pos.customer_detail')
                        }}</span>
                    </div>
                </div>
                <div @click="goto_step(2)" :style="wizard.current_step > 1 ? 'cursor: pointer !important;' : ''">
                    <div class="text-center mt-2">
                    <span :style="wizard.current_step > 1 ? 'color: #00bea5' :'color: #d2d2d2'">{{
                            $t('pos.account_detail')
                        }}</span>
                    </div>
                </div>
                <div @click="goto_step(3)" :style="wizard.current_step > 2 ? 'cursor: pointer !important;' : ''">
                    <div class="text-center mt-2">
                    <span :style="wizard.current_step > 2 ? 'color: #00bea5' :'color: #d2d2d2'">{{
                            $t('pos.device_info')
                        }}</span>
                    </div>
                </div>
                <div @click="goto_step(4)" :style="wizard.current_step > 3 ? 'cursor: pointer !important;' : ''">
                    <div class="text-center mt-2">
                    <span :style="wizard.current_step > 3 ? 'color: #00bea5' :'color: #d2d2d2'">{{
                            $t('pos.address_info')
                        }}</span>
                    </div>
                </div>
                <div @click="goto_step(5)" :style="wizard.current_step > 4 ? 'cursor: pointer !important;' : ''">
                    <div class="text-center mt-2">
                    <span :style="wizard.current_step > 4 ? 'color: #00bea5' :'color: #d2d2d2'">{{
                            $t('pos.documents')
                        }}</span>
                    </div>
                </div>
            </div>

            <hr class="custom_hr" v-if="wizard.current_step > 0">

            <div class="p-5" v-if="constants && request_details">
                <div v-show="wizard.current_step === 1">
                    <customer-detail v-if="request_details" :wizard="wizard"
                                     :form_data="request_details"></customer-detail>
                </div>
                <div v-show="wizard.current_step === 2">
                    <bank-account v-if="request_details" :wizard="wizard"
                                  :request_details="request_details"></bank-account>
                </div>
                <div v-show="wizard.current_step === 3">
                    <device-info :form_data="request_details" :wizard="wizard"></device-info>
                </div>
                <div v-show="wizard.current_step === 4">
                    <address-info :form_data="request_details" :wizard="wizard"></address-info>
                </div>
                <div v-show="wizard.current_step === 5">
                    <documents :form_data="request_details" :wizard="wizard" :register="editPosRequest"></documents>
                </div>
                <PosRequestDescription v-if="request_details.status == posStatuses.CORRECTION"
                                       :description="request_details.description"></PosRequestDescription>
            </div>
        </div>
    </main-content>
</template>

<script>


import toastr from "toastr";
import $ from "jquery";
import {KTApp} from '@/plugins/core/app';
import {i18n} from '@/plugins/i18n';
import {posStatuses,manageDocuments} from '@/constants/PosStatus'
// import AccountDetail from "./bank-account-detail";
import PosRequestDescription from "./pos-request-description";
import DeviceInfo from "../device-info";
import AddressInfo from "../address-info";
import Documents from "../documents/pos-documents";
import customerDetail from "../customer-detail";
import bankAccount from "../editPosRequests/bank-account-detail";
import {mapGetters} from "vuex";
import MainContent from "../../../../components/main-content";
import {posService} from '@/common/api.service'
import {KTUtil} from '@/plugins/core/util'


export default {
    components: {
        MainContent,
        'device-info': DeviceInfo,
        'documents': Documents,
        'address-info': AddressInfo,
        // 'account-detail': AccountDetail,\
        customerDetail,
        bankAccount,
        PosRequestDescription,
    },
    data() {
        return {
            posStatuses,
            wizard: {
                current_step: 1,
                show: true,
                navigable: true,
                submit_in_progress: false,
                newCustomer: false,
                operation: 'watch',
                document_operation: manageDocuments.WATCH,
            },
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            currentTab: 1,
            manageDocuments
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
        request_details: {},
        ...mapGetters('pos', [
            'constants', 'request_details', 'psp'
        ])
    },
    mounted() {
        this.$store.dispatch('pos/fetch')
        this.$store.dispatch('pos/getRequestDetails', this.$route.params.hashid).then(()=>{
            if (this.request_details.status != posStatuses.ACTIVE && (this.request_details.status == posStatuses.PENDING ||
                    this.request_details.status == posStatuses.CORRECTION ||
                    (this.$can('manage','pos') && this.request_details.status == posStatuses.AGENCY_CHECK))){
                this.wizard.operation ='edit'
                this.canChangeDocuments()
            }
        })
    },

    methods: {
        editPosRequest(btn, form, hidden_btn) {
            KTApp.progress(btn)
            let bank_account_detail = structuredClone(this.request_details.bank_account_detail);
            delete bank_account_detail.multi_account_details
            delete bank_account_detail.multi_account_owners
            let documents = structuredClone(this.request_details.documents);
            for (var key in documents) {
                if (!documents[key].type) {
                    delete documents[key]
                }
            }
            let params = {
                ...documents, ...this.request_details.address_info, ...this.request_details.device_info,
                stakeholders: this.request_details.stakeholders,
                multi_account_owners: this.request_details.sub_customers,
                ...this.request_details.customer_detail, ...bank_account_detail,
                status: this.request_details.status,
                id: this.request_details.id,
                psp: this.psp
            }
            for (let key in params) {
                if (params[key] == null) params[key] = ''
            }
            posService.editPosRequest(params).then(response => {
                this.$router.push('/pos')
            }).catch(({response}) => {
                KTApp.unprogress(btn)
                if (response.data) {
                    let message = document.createElement('div')
                    message.innerHTML = response.data.message
                    Object.keys(response.data.data).forEach(function (item) {
                        var li = document.createElement('li')
                        li.innerText = response.data.data[item][0]
                        message.insertAdjacentElement('beforeend', li)
                    })
                    hidden_btn.style.display = 'inline'
                    KTUtil.scrollTop();
                    return this.showMsg(form, 'danger', message)
                }
            })
        },
        goto_step(selected_step) {
            if (this.wizard.navigable && (this.wizard.current_step > selected_step)) {
                this.wizard.current_step = selected_step;
            }
        },
        afterDispatch() {
            setTimeout(
                    $('.kt-selectpicker').selectpicker({
                        size: 6,
                        liveSearch: false,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_chose')

                    }), 2000)


        },
        changeLabel() {
            let label = $('#is_multi_account_label')
            let checkbox = $('#is_multi_account')

            if (checkbox.is(':checked')) {
                label.html(i18n.t('label.active'))
            } else {
                label.html(i18n.t('label.inactive'))
            }
        },
        canChangeDocuments() {
            if (this.wizard.operation == 'edit') {
                return this.wizard.document_operation = manageDocuments.EDIT
            }
            if (this.request_details.status === posStatuses.CORRECTION || this.request_details.status === posStatuses.PENDING){
                return this.wizard.document_operation = manageDocuments.EDIT
            }
            return this.wizard.document_operation = manageDocuments.WATCH
        }
    },
}
</script>

<style scoped>

.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}

.filter_green {
    filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg) brightness(91%) contrast(101%);
}

.filter_gray {
    filter: invert(87%) sepia(1%) saturate(200%) hue-rotate(314deg) brightness(101%) contrast(86%);
}

.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type="file"]::-webkit-file-upload-button {
    visibility: hidden;
}
</style>